<template>
    <TopNav></TopNav>
		<h1>Tip Calculator</h1>
		<fieldset>
      <legend>TipCalculator</legend>
      <label for="pr" class="leftLabel">Price:</label> <input type="number" v-model.number="price" step="any" @input="onPriceChange" autofocus id="pr"> <label for="pr">$</label>
			<br>
      <label for="ti" class="leftLabel">Tip:</label> <input type="number" v-model.number="tip" step="any" @input="onTipChange" id="ti"> <label for="ti">%</label>
      <br>
      <label for="to" class="leftLabel">Total:</label> <input type="number" v-model.number="total" step="any" @input="onTotalChange" id="to"> <label for="to">$</label>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Tip",
  data() {
    return {
      price: 100,
      tip: 10,
      total: 110,
    }
  },
  components: {
    TopNav
  },
  methods: {
    onPriceChange(e) {
      const price = e.currentTarget.value;
      const priceNumber = Number(price);
      this.total = (price * this.tip / 100) + priceNumber;
    },
    onTipChange(e) {
      const tip = e.currentTarget.value;
      const tipNumber = Number(tip);
      this.total = (this.price * tipNumber / 100) + this.price;
    },
    onTotalChange(e) {
      const total = e.currentTarget.value;
      const totalNumber = Number(total);
      this.tip = 100 * (totalNumber - this.price) / this.price;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
  display: inline-block;
  width: 70px;
}

input[type=number] {
    width: 90px;
}

footer section a {
  margin: 20px;
}
</style>
